/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type CommunicationsStatusPageCreateEntrypointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const communicationsStatusPageCreateEntrypoint: EntryPoint<
	CommunicationsStatusPageCreateEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<CommunicationsStatusPageCreateEntrypointComponent>(
		/* webpackChunkName: "async-communications-status-page-create-entrypoint" */ './ui/StatusPageCreatePage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => {
		return {};
	},
});
